/**
 * Build Game Data Envs
 */
export enum BuildGameDataEnvs
{
    Dev = 0,
    Stage = 1,
    QA = 2,
    Prod = 3
}